export default __webpack_public_path__ + "static/media/dalengarden.a6192ecf.jpg";